import { message } from "antd";
import { handleResponse } from "../../../../common/handleLambdaResponse";
import { getIdToken } from "../../../userManager/userManagementUtils";

export const getStripePaymentURL = (): Promise<string> => {
    return new Promise(async (resolve, reject) => {
        // Example call to Lambda function
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Failed to get url")
            reject(err);
            return
        }
        const params = {
            FunctionName: "stripe_operations",
            Payload: JSON.stringify({
                action: "get_stripe_redirect_url",
                token: idToken
            })
        };

        window.lambda.invoke(params, (err: any, resultData: any) => {
            handleResponse(err, resultData, resolve, reject)
        });
    })
}

export const get_billing_info = (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Failed to get rates")
            reject(err);
        }
        const payload = {
            action: "get_billing_info",
            token: idToken,
        }
        const params = {
            FunctionName: "transaction-log",
            Payload: JSON.stringify(payload)
        };

        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject)
        }
        )
    })
}

export const get_invoices = (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Failed to get invoices")
            reject(err);
        }
        const payload = {
            action: "get_invoices",
            token: idToken,
        }
        const params = {
            FunctionName: "transaction-log",
            Payload: JSON.stringify(payload)
        };

        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject)
        }
        )
    })
}